export const numberFormatter = (num: number, digits: number, abbreviate_thousands?: boolean) => {
  var si = [
      { value: 1E18, symbol: " E" },
      { value: 1E15, symbol: " P" },
      { value: 1E12, symbol: " T" },
      { value: 1E9,  symbol: " B" },
      { value: 1E6,  symbol: " M" },
      { value: 1E3,  symbol: "k" }
  ], rx = /\.0+$|(\.[0-9]*[1-9])+$/, i;
  for (i = 0; i < si.length; i++) {
      if (num >= si[i].value) {
          if (si[i].value === 1E3 && !abbreviate_thousands) {
              var nstring = ''+num;
              var len = nstring.length;
              if (nstring.includes('.')) {
                var splitOnDecimal = nstring.split('.')
                var wholeNumber = splitOnDecimal[0]
                var decimalPosition = splitOnDecimal[1]
                var back = wholeNumber.slice(wholeNumber.length -3, wholeNumber.length)
                var front = wholeNumber.slice(0, wholeNumber.length -3)
                return `${front},${back}.${decimalPosition}`
              } else {
                var back = nstring.slice(len-3,len);
                var front = nstring.slice(0,len-3);
                return front+','+back;
              } 
          } else {
              return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
          }
      }
  }
  return num.toFixed(digits).replace(rx, "$1");
}

export function roundTo(value: number, decimals: number): number {
  const factor = Math.pow(10, decimals);
  return Math.round(value * factor) / factor;
}
export function sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const PHONE_PREFIX = '+1';
export const PHONE_PREFIX_WITH_DASH = `${PHONE_PREFIX}-`;

export const normalizePhoneNumber = (value?: string): string => {
  const rawValue = String(value ?? '');
  const hasManualTrailingHyphen = rawValue.trimEnd().endsWith('-');
  const sanitizedValue = rawValue.startsWith(PHONE_PREFIX) ? rawValue.slice(PHONE_PREFIX.length) : rawValue;
  const digits = sanitizedValue.replace(/\D/g, '').slice(0, 10);

  if (!digits.length) {
    return PHONE_PREFIX_WITH_DASH;
  }

  let formatted = `${PHONE_PREFIX_WITH_DASH}${digits.slice(0, 3)}`;

  if (digits.length > 3) {
    formatted += `-${digits.slice(3, 6)}`;
  }

  if (digits.length > 6) {
    formatted += `-${digits.slice(6, 10)}`;
  } else if (hasManualTrailingHyphen && digits.length < 10) {
    formatted += '-';
  }

  return formatted;
};

export const formatPhoneNumber = (value?: string): string => normalizePhoneNumber(value);

export const getMinEventDate = (): string => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const year = tomorrow.getFullYear();
  const month = String(tomorrow.getMonth() + 1).padStart(2, '0');
  const day = String(tomorrow.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const clampEventDate = (value: string, minDate: string): string => {
  if (!value) {
    return value;
  }

  return value < minDate ? minDate : value;
};

export const shouldPreventPhonePrefixDeletion = (
  event: React.KeyboardEvent<HTMLElement>,
): boolean => {
  if (event.key !== 'Backspace' && event.key !== 'Delete') {
    return false;
  }

  const target = event.target as HTMLInputElement | HTMLTextAreaElement | null;
  if (!target || typeof target.value !== 'string') {
    return false;
  }

  const currentValue = target.value ?? '';
  if (!currentValue.startsWith(PHONE_PREFIX_WITH_DASH)) {
    return false;
  }

  const selectionStart = target.selectionStart ?? currentValue.length;
  const selectionEnd = target.selectionEnd ?? currentValue.length;
  const hasSelection = selectionStart !== selectionEnd;
  const prefixLength = PHONE_PREFIX_WITH_DASH.length;

  if (hasSelection) {
    return selectionStart < prefixLength;
  }

  if (event.key === 'Backspace') {
    return selectionStart <= prefixLength;
  }

  return selectionStart < prefixLength;
};

export type DashboardMenuKey = 'docs' | 'verify-users' | 'user-management' | 'location-management' | 'access-logs';

const dashboardRoleRank: Record<string, number> = {
  teammember: 0,
  manager: 1,
  admin: 2,
  owner: 2,
};

export function canAccessDashboardRoute(role: string | undefined, entryKey: DashboardMenuKey): boolean {
  const currentRole = role ?? 'teammember';

  if (entryKey === 'verify-users') {
    return currentRole !== 'teammember';
  }

  if (entryKey === 'access-logs') {
    return (dashboardRoleRank[currentRole] ?? 0) >= 2;
  }

  if (entryKey === 'user-management') {
    return currentRole !== 'teammember';
  }

  if (entryKey === 'location-management') {
    return (dashboardRoleRank[currentRole] ?? 0) >= 2;
  }

  return true;
}